export default {
	setNavMenuHidden({ commit }) {
		commit('setShowNavMenu', false);
	},
	setNavMenuVisible({ commit }) {
		commit('setShowNavMenu', true);
	},
	toggleNavMenu({ state, commit }) {
		commit('setShowNavMenu', !state.showNavMenu);
	}
};